// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_smzCx clearfix","box_r":"index_box_r_S6ZWD","d_box":"index_d_box_RVbCb"};